import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();
export { toast };
//# sourceMappingURL=toast.js.map